export default __webpack_public_path__ + "static/media/green-loading.c835bb07.gif";